module.exports = __webpack_public_path__ + "static/donnaandbf-3a253035024cfeea0eae4c883b4adf16.jpg";